import editPricesModificationsStore from "./modifications.store";
import editPriceFiltersStore from './filters.store';

export default {
    editPricesModificationsStore,
    editPriceFiltersStore
};
